import type { LatLng, Map as LeafletMap, LeafletMouseEvent } from "leaflet"
import { useEffect } from "react"
import type { ReactElement } from "react"
import { useMap } from "react-leaflet"

export interface IMapViewerClickHandlerProps {
  onClick: (latlng: LatLng) => void
}

export function MapViewerClickHandler(props: IMapViewerClickHandlerProps): ReactElement {
  const { onClick } = props
  const map: LeafletMap = useMap()

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    map.on("click", handleOnClick)

    return () => {
      map.off("click", handleOnClick)
    }
  }, [])

  function handleOnClick(event: LeafletMouseEvent): void {
    const position: LatLng = event.latlng

    onClick(position)
  }

  return <></>
}
